import React from 'react';
import CustomLink from '@/components/common/CustomLink';
import formatWebAddress from '@/utils/formatWebAddress';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
export default function AnnouncementSummary({ entity }: any) {
  // @ts-expect-error TS(2525) TODO(ts-migrate): Initializer provides no value for this binding ele... Remove this comment to see the full error message
  const { link, message, websitePreview: { description, title } = {} } = entity;

  return (
    <div>
      {link && (
        <div>
          <CustomLink>{formatWebAddress(link)}</CustomLink>
        </div>
      )}

      {description && <p>{description}</p>}

      {title && (
        <div>
          <strong>{title}</strong>
        </div>
      )}

      <span className="whitespace-pre-line">{message}</span>
    </div>
  );
}
